import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { createApiAction } from 'api'
import {
  getSystemInformation,
  getCustomerInformation,
  getCustomerInformationFromRealm,
} from 'core/system/api/systemService'
import { SystemState, ApiSystemInformationResponse, ApiCustomerInformationResponse } from './types'

const initialState: SystemState = {
  systemInformation: {},
  customerInformation: {},
}

const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    systemInformationLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiSystemInformationResponse>>
    ) {
      state.systemInformation = action.payload
    },
    customerInformationLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiCustomerInformationResponse>>
    ) {
      state.customerInformation = action.payload
    },
  },
})

const { systemInformationLoaded, customerInformationLoaded } = systemSlice.actions
export default systemSlice.reducer

export const loadSystemConfiguration = () => {
  return createApiAction({
    apiCalls: {
      information: getSystemInformation,
    },
    payloadAction: systemInformationLoaded,
    enableErrorNotification: true,
  })
}

export const loadCustomerConfiguration = (company?: string) => {
  return createApiAction({
    apiCalls: {
      information: () => getCustomerInformation(company),
    },
    payloadAction: customerInformationLoaded,
    enableErrorNotification: true,
  })
}

export const loadCustomerConfigurationFromRealm = (realm?: string) => {
  return createApiAction({
    apiCalls: {
      information: () => getCustomerInformationFromRealm(realm),
    },
    payloadAction: customerInformationLoaded,
    enableErrorNotification: true,
  })
}
